"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gameOver = gameOver;

require("pixi");

require("p2");

var _phaser = _interopRequireDefault(require("phaser"));

var _game = _interopRequireDefault(require("./game"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var game;
var timer = null;

window.onload = function () {
  $(document).ready(function () {
    game = new _game.default();
    $(".js-screen .js-button").on('click', function () {
      if (timer != null) {
        clearTimeout(timer);
        timer = null;
      }

      if ($(this).is(":visible")) {
        if ($(this).data('next') != undefined && !DEBUG) {
          $(".js-screen").removeClass('active');
          $(".js-screen." + $(this).data('next')).addClass('active');
        } else {
          $(".js-screen").removeClass('active');
          $(".js-screen.js-game").addClass('active');
          game.startGame();
        }
      }
    });
    $(".js-marker").on('click touch', function () {
      if ($(this).hasClass('active')) {
        $(".js-marker").removeClass('active');
      } else {
        $(".js-marker").removeClass('active');
        $(this).addClass('active');
      }
    });
    $(".js-instructions").on('click', function (e) {
      if ($(e.target).parents('.js-marker').length == 0) {
        $(".js-marker").removeClass('active');
      }
    });
  });
};

function gameOver(score) {
  $(".js-screen").removeClass('active');
  $(".js-screen.js-game-over").addClass('active');
  $(".js-score").text(score);
  timer = setTimeout(function () {
    $(".js-game-over .js-button").trigger('click');
  }, 20000);
}